import { useEffect, useState } from "react";

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(null);

  const updateDimensions = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    let timer;
    const handlerOnReize = () => {
      clearTimeout(timer);
      timer = setTimeout(() => updateDimensions(), 100);
    };
    window.addEventListener("resize", handlerOnReize, false);
    updateDimensions();
  }, []);

  return { isMobile };
};
